// Shared stage list (kept identical to backend/constants.py).
export const STAGES = [
  "MG1", "MG2/BP1", "FP1", "BP2", "FP2", "PreL", "Launch", "Post Launch",
];

export const STATUSES = ["Active", "Launched", "Dropped Out"];
